 <template>
  <div></div>
</template>

<script>
export default {
  props: ["downFun"],
  watch: {
    downFun(val) {
      if (val) {
        this.openIframeApp();
      }
    },
  },
  mounted() {
    // check if is xijing channel
    if (this.getQueryVariable("isXijing") == 1 || this.getQueryVariable("newXijing") == 1) {
      window.isXijingChannel = true;
      (function () {
        var agl = document.createElement('script');
        agl.type ='text/javascript';
        agl.async = true;
        agl.src = document.location.protocol + '//i.gtimg.cn/ams-web/public/mobile-market/dist/api.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(agl, s);
      })();
    }
    // check if is alipay mini program channel
    if (this.getQueryVariable("isAlipay") == 1) {
      window.isAlipay = true;
    }
    // check if is wechat channel
    if (this.getQueryVariable("isWechat") == 1) {
      window.isWechat = true;
    }
    // check if is wechat mini program channel
    if (this.getQueryVariable("isWechatMiniProgram") == 1) {
      window.isWechatMiniProgram = true;
    }
    // check is need use vivo store dowmload
    if (this.getQueryVariable("isUseVivoStoreDownload") == 1) {
      window.isUseVivoStoreDownload = true;
    }
  },
  methods: {
    openIframeApp() {
      function getQueryVariable(word) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == word) {
            return pair[1];
          }
        }
        return false;
      }
      function checkToutiaoLink(link) {
          const codes = ['hfq03823','hfq03586','hfq0399t','hfq03942','hfq0399h','hfq03625','hfq03758'];
          for (const code of codes) {
              if (link.includes(code)) {
                  return true;
              }
          }
          return false;
      }
      
      // 鸿蒙系统跳转鸿蒙应用商店
      if (this.downloadInHarmony()) {
        return false;
      }

      // 蹊径渠道使用蹊径下载页面
      if (this.downloadUseXijing()) {
        return false;
      }

      // 支付宝小程序使用下载引导页面
      if (window.isAlipay || window.isWechatMiniProgram) {
        let url =`https://api-m.we.cn/appv3/alipay-down${location.search}`;
        url += (url.indexOf("?") === -1 ? "?" : "&") +
        `Template=${
          window.templateName || document.title
        }&userkey=${sessionStorage.getItem('userkey')}`;
        window.location.href = url;
        return;
      }

      // 微信投放使用
      if (window.isWechat) {
        let url =`https://api-m.we.cn/appv3/wechat-download${location.search}`;
        url += (url.indexOf("?") === -1 ? "?" : "&") +
        `Template=${
          window.templateName || document.title
        }&userkey=${sessionStorage.getItem('userkey')}`;
        window.location.href = url;
        return;
      }

      var ua = navigator.userAgent.toLowerCase();
      var platform = {
        // android终端或者uc浏览器
        android: ua.indexOf("android") > -1 || ua.indexOf("linux") > -1,
        androidVersion: 0,
        // 是否为iPhone或者QQHD浏览器
        iPhone: ua.indexOf("iphone") > -1,
        // 是否iPadip
        iPad: ua.indexOf("ipad") > -1,
        //ios version
        iosVersion: 0,
        //windows phone
        wPhone: ua.indexOf("windows phone") > -1,
        //是否在 微信 客户端内
        isWeixin: ua.indexOf("micromessenger") > -1,
        mfAndroid:
          ua.indexOf("android") > -1 ||
          ua.indexOf("adr") > -1 ||
          ua.indexOf("linux") > -1,
        mfAldb: ua.indexOf("magicloan") > -1,
      };

      var out = /iphone os (\d+)/.exec(ua);
      if (out) {
        platform.iosVersion = parseInt(out[1], 10);
      } else if ((out = /android (\d+)/.exec(ua))) {
        platform.androidVersion = parseInt(out[1], 10);
      }

      //针对ios客户端屏蔽操作
      var browserHidden = function() {
        if (typeof document.hidden !== "undefined") {
          return document.hidden;
        } else if (typeof document.mozHidden !== "undefined") {
          return document.mozHidden;
        } else if (typeof document.msHidden !== "undefined") {
          return document.msHidden;
        } else if (typeof document.webkitHidden !== "undefined") {
          return document.webkitHidden;
        }
        return false;
      };

      //下面代码来自网络,创建一个iframe,延迟后判断是否页面跳转了
      function callNative(url, callback, universalLinks) {
        if (!url) {
          return;
        }

        var oFrame = document.createElement("iframe");
        oFrame.style.display = "none";
        var body = document.body;
        var timer;
        var clear = function(evt, isTimeout) {
          typeof callback === "function" && callback(isTimeout);
          window.removeEventListener("pagehide", hide, true);
          if (!oFrame) {
            return;
          }

          oFrame.onload = null;
          body.removeChild(oFrame);
          oFrame = null;
        };
        var hide = function(e) {
          clearTimeout(timer);
          clear(e, false);
        };
        var timer1 = 70,
          timer2 = 1200,
          timerDuration = 1300;

        window.addEventListener("pagehide", hide, true);
        if (platform.iosVersion >= 9) {
          oFrame = null;
          if (universalLinks && this.options.isDebug) {
            window.location.href = universalLinks;
          } else {
            window.location.href = url;
          }
        } else {
          oFrame.onload = clear;
          oFrame.src = url == "http://haohuan" ? "haohuan://" : url;
          body.appendChild(oFrame);
        }

        var startTime = +new Date();
        timer = setTimeout(function() {
          timer = setTimeout(function() {
            var newTime = +new Date();
            var duration = newTime - startTime;
            if (duration > timerDuration) {
              clear(null, false);
            } else if (!browserHidden()) {
              clear(null, true);
            }
          }, timer2);
        }, timer1);
      }
      let downloadType = getQueryVariable("downloadType") || "mobile";
      let phone = getQueryVariable("phone");

      let composite = getQueryVariable("composite");
      let source;
      if (composite) {
        const compositeArr = composite.split("_");
        source = compositeArr[0];
      }

      !(function() {
        var YING_YONG_BAO_URL =
          "http://sj.qq.com/myapp/detail.htm?apkName=com.renrendai.haohuan";
        var appStoreURL = "https://itunes.apple.com/cn/app/id1309415987?mt=8"; //主包
        var androidDownloadURL = `https://d.weicai.com.cn/download/android/haohuan_release.apk`;
        var APP_SCHEMA = "http://haohuan";
        var universalLinks = "https://api-m.haohuan.com?debug=true";

        if (platform.mfAndroid && platform.mfAldb) {
          APP_SCHEMA = "aldb://magincloan?v=1.1&p=haohuan://";
          androidDownloadURL =
            "aldb://magincloan?v=1.1&p=https://d.weicai.com.cn/download/android/haohuan_release.apk";
        }
        var isxjbk = getQueryVariable("xjbk");
        if (isxjbk) {
          //都是马甲包，后面正式包上线需要替换
          androidDownloadURL =
            "https://hn.xianjincard.com/download?url=https://d.weicai.com.cn/download/android/haohuan_release.apk";
          appStoreURL =
            "itms-appss://itunes.apple.com/cn/app/id1309415987?mt=8";
        }

        if (platform.wPhone) {
          alert("抱歉，暂不支持您的设备");
          return;
        }

        var finalDownloadURL = androidDownloadURL;
        if (platform.iPhone || platform.iPad) {
          APP_SCHEMA = "haohuan://";
          finalDownloadURL = appStoreURL;
          if (!platform.isWeixin) {
            if (getQueryVariable("utm_source") == "xrqb") {
              appStoreURL =
                "itms-appss://itunes.apple.com/cn/app/id1309415987?mt=8";
            } else {
              appStoreURL = "https://itunes.apple.com/cn/app/id1309415987?mt=8";
            }
            window.location.href = appStoreURL;
            return false;
          }
        }

        const deepType = getQueryVariable("deep_type") || '';
        const isToutiao = deepType.indexOf('toutiao') > -1;
        const isToutiaoOrigin = getQueryVariable("hfqorigin") || '';
        
        const utmSource = getQueryVariable("utm_source") || '';
        const isUtmSourceStartToutiao = utmSource.indexOf('toutiao') > -1;

        if (platform.android && isUtmSourceStartToutiao) {
          window.location.href = "https://apps.bytesfield.com/download/basic/cur/50eb94761e6a80e92d2b175cf2a4bf82ef2bb251";
          return;
        }

        if (platform.android && isToutiao) {
          APP_SCHEMA = null;
          finalDownloadURL = "https://apps.bytesfield.com/download/basic/cur/50eb94761e6a80e92d2b175cf2a4bf82ef2bb251";
        }
        if (platform.android && checkToutiaoLink(isToutiaoOrigin)) {
          APP_SCHEMA = null;
          finalDownloadURL = "https://apps.bytesfield.com/download/basic/cur/50eb94761e6a80e92d2b175cf2a4bf82ef2bb251";
        }

        if (platform.isWeixin) {
          APP_SCHEMA = null;
          finalDownloadURL = YING_YONG_BAO_URL;
        }

        if (platform.android && window.isUseVivoStoreDownload) {
            APP_SCHEMA = null;
            finalDownloadURL =
              "market://details?id=com.renrendai.haohuan&th_name=com.renrendai.haohuan";
          }

        const downType = getQueryVariable("down_type");
        // 分媒体跳转指定链接
        if (downType === 'APPstore' && platform.android) {
          const isHonor = /honor/i.test(ua) && !/huawei/i.test(ua); // 荣耀（独立品牌）
          const isHuawei = /huawei/i.test(ua); // 华为&早期荣耀
          const isVivo = /vivo|iqoo/i.test(ua); // vivo
          if (isHonor) {
            APP_SCHEMA = null;
            finalDownloadURL = "market://details?id=com.renrendai.haohuan";
          } else if (isHuawei) {
            APP_SCHEMA = null;
            finalDownloadURL = "https://appgallery.huawei.com/app/C100172469";
          } else if (isVivo) {
            APP_SCHEMA = null;
            finalDownloadURL = "https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=2030171";
          }
        }

        if (APP_SCHEMA) {
          if (
            finalDownloadURL.indexOf(
              "https://d.weicai.com.cn/download/android/haohuan_release.apk",
            ) >= 0
          ) {
            window.location.href = finalDownloadURL;
            return false;
          }
          //先尝试调起本地APP
          callNative(
            APP_SCHEMA,
            function(isTimeout) {
              if (isTimeout) {
                setTimeout(function() {
                  window.location.href = finalDownloadURL;
                }, 0);
              } else {
                window.location.href = finalDownloadURL;
                return false;
              }
            },
            universalLinks,
          );
        } else {
          window.location.href = finalDownloadURL;
        }
      })();
    },
    downloadUseXijing() {
      if (!window.isXijingChannel) return false;
      if (window.AmsAppApi && typeof window.AmsAppApi.invokeLandingPage === 'function') {
        try {
          const isNewXijing = this.getQueryVariable("newXijing") == 1;
          const androidAppUrl = isNewXijing ? 'https://h5.gdt.qq.com/xjviewer/nemo/29638564?xj_nocdn=1' : 'https://h5.gdt.qq.com/xjviewer/nemo/2141363';
          const iosAppUrl = isNewXijing ? 'https://h5.gdt.qq.com/xjviewer/nemo/29638564?xj_nocdn=1' : 'https://h5.gdt.qq.com/xjviewer/nemo/2141332';
          window.AmsAppApi.invokeLandingPage({
            androidAppUrl,
            iosAppUrl,
            autodownload: true, // 开启自动下载
            callback: res =>  {
              // 跳转类型为nothing时，建议做兜底逻辑处理
              if (res && res.type === 'nothing') {
                  window.isXijingChannel = false;
                  this.openIframeApp();
              }
            }
          });
        } catch(e){
          return false;
        }
        return true;
      }
      return false;
    },
    downloadInHarmony() {
      const userAgent = navigator.userAgent;
      console.log('userAgent', userAgent);
      if(/OpenHarmony/i.test(userAgent)) {
        window.location.href = "https://appgallery.huawei.com/app/detail?id=com.hfq.loan.hm";
        return true;
      }
      return false;
    },
    // 获取地址栏参数
    getQueryVariable(word) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == word) {
          return pair[1];
        }
      }
      return false;
    }
  },
};
</script>
